import _defaults from 'lodash/defaults'
import _each from 'lodash/each'

export default {
  getters: {
    UploadedDocuments: (state, getters) => {
      return _defaults(
        getters.currentTripDashboardId
          ? getters.Trips[getters.currentTripDashboardId].uploaded_documents
          : {},
        {
          'section-heading': 'Your Documents',
          'section-subheading': "<p>Here you will find all documents you've shared with us.</p>",
          resource_stores: []
        }
      )
    },
    UploadedAttachments: (state, getters) => {
      let attachments = []

      // To Do Attachments
      _each(getters.ToDoItems, function (i) {
        if (i.attachments.length) {
          _each(i.attachments, function (a) {
            if (a) {
              attachments.push(Number.isInteger(a) ? a : a.id)
            }
          })
        }
      })

      // Manual Attachments
      _each(getters.UploadedDocuments.manual_attachments, function (a) {
        if (a) {
          attachments.push(Number.isInteger(a) ? a : a.id)
        }
      })

      return { files: attachments }
    },

    TodoResourceStore: (state, getters) => {
      let attachmentsFromTodo = []
      _each(getters.ToDoItems, function (i) {
        if (i.attachments.length) {
          _each(i.attachments, function (a) {
            if (a) {
              attachmentsFromTodo.push(Number.isInteger(a) ? a : a.id)
            }
          })
        }
      })

      return {
        title: 'Uploaded on Todo List',
        files: attachmentsFromTodo
      }
    }
  }
}
